export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=229454f3&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/leads/view/index.vue?vue&type=template&id=229454f3&
// module id = 1178
// module chunks = 0